<!-- 组织分组 -->
<template>
    <div class='page_content'>
        <organizationGroupAction ref="organizationGroupAction"></organizationGroupAction>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" :buttonFlag="false" :showRefresh="true" @actionSet="actionSet" @getPageInfo="getDataList"></v-button>
            <div class="page_content_top_line">
                <el-form :inline="true" :model="getRequestData" class="demo-form-inline dis" size="mini" @submit.native.prevent>
                    <el-form-item label="名称" class="pd">
                        <el-input class="form_codition" v-model.trim="getRequestData.orgName" :maxlength="$store.state.inputLength" size="mini" clearable placeholder="请输入名称" @keyup.enter.native="searchData"></el-input>
                    </el-form-item>
                    <el-form-item class="pd">
                        <el-button type="primary" icon="el-icon-search" size="mini" @click="searchData">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="page_content_center" v-loading="tableLoading">
            <el-table size="mini" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row @row-click="onRowClick">
                <el-table-column label="选择" width="70" align="center">
                    <template slot-scope="scope">
                        <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                            <i class="el-icon-thumb"></i>
                        </el-radio>
                    </template>
                </el-table-column>
                <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                <el-table-column prop="orgName" label="名称" min-width="180" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="orgCode" label="编码" min-width="160" show-overflow-tooltip align="center"></el-table-column>
            </el-table>
        </div>
        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>
    </div>
</template>

<script>
import organizationGroupAction from "@/components/organizationGroupAction.vue";
export default {
    components: { organizationGroupAction },
    data() {
        return {
            tableHeight: 0,
            tableLoading: false,
            buttonList: [],
            getRequestData: {
                orgName: '',
                page: 1,
                rows: 30,
            },
            returnData: {
                pages: 0,
                total: 0,
                pageNum: 0,
                list: []
            },
            selectedDataIndex: 0,
        };
    },
    computed: {},
    watch: {},
    methods: {
        onRowClick(row) {
            const index = this.returnData.list.indexOf(row)
            if (index > -1) {
                this.selectedDataIndex = index
            }
        },
        actionSet(actionData) {
            switch (actionData.actionType) {
                case 0:
                    this.$refs['organizationGroupAction'].openBox(actionData.actionType)
                    break;
                case 1:
                    if (this.returnData.list <= 0) {
                        this.$message({
                            message: '暂无数据',
                            type: 'error'
                        });
                        return false
                    }
                    var dataInfo = this.returnData.list[this.selectedDataIndex]
                    if (!dataInfo) {
                        this.$message({
                            message: '请先选中要操作的数据',
                            type: 'error'
                        });
                        return false
                    }
                    this.$refs['organizationGroupAction'].openBox(actionData.actionType, dataInfo)
                    break;
                case 2:
                    this.delDataAction()
                    break;
            }
        },
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
        },
        searchData() {
            this.getRequestData.page = 1
            this.getDataList()
        },
        delDataAction() {
            if (this.returnData.list <= 0) {
                this.$message({
                    message: '暂无数据',
                    type: 'error'
                });
                return false
            }
            var dataInfo = this.returnData.list[this.selectedDataIndex]
            if (!dataInfo) {
                this.$message({
                    message: '请先选中要操作的数据',
                    type: 'error'
                });
                return false
            }
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                var delData = {
                    ids: [dataInfo.orgId]
                }
                let responseData = await this.$http.delOrganizationType(delData)
                if (responseData.status == 200) {
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                    this.getDataList()
                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    });
                }
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        setDataPageNumber(val) {
            this.getRequestData.page = val
            this.getDataList()
        },
        setDataPageSize(val) {
            this.getRequestData.page = 1
            this.getRequestData.rows = val
            this.getDataList()
        },
        async getDataList() {
            this.tableLoading = true
            try {
                let responseData = await this.$http.getOrganizationType(this.getRequestData)
                if (responseData.status == 200) {
                    this.returnData.list = responseData.result.list
                    this.returnData.pages = responseData.result.pages
                    this.returnData.total = responseData.result.total
                    this.returnData.pageNum = responseData.result.pageNum
                    this.selectedDataIndex = 0
                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    });
                }
            } finally {
                this.tableLoading = false
            }
        },
    },
    created() {
        this.getDataList()
        this.getButtonList()
    },
    mounted() { },
    updated() {
        this.tableHeight = this.$common.getTableHeight()
    },
    activated() {
        this.tableHeight = this.$common.getTableHeight()
    },
}
</script>
<style scoped>
.dis {
    display: flex;
    flex-wrap: wrap !important;
}

.page_content_top_line {
    padding-bottom: 0;
}
</style>
